export type CalculatorFormData = {
  income_user_gross: string;
  income_user_net: string;
  checkbox_income_user: boolean;
  child_1_age: number | null;
  child_2_age: number | null;
  has_partner: boolean;
  shared_household: boolean;
  income_partner_gross: string;
  income_partner_net: string;
  checkbox_income_partner: boolean;
  pregnant: boolean;
  has_children: boolean;
  children_0_5: number;
  children_6_13: number;
  children_14_17: number;
  children_18_24_non_working: number;
  rental_income: string;
  unemployment_benefit: string;
  pension: string;
  other_income_amount: string;
  checkbox_other_income: boolean;
  cold_rent: string;
  additional_costs: string;
  heating_costs: string;
  checkbox_housing_costs: boolean;
};

export const defaultFormData: CalculatorFormData = {
  income_user_gross: '',
  income_user_net: '',
  checkbox_income_user: false,
  child_1_age: null,
  child_2_age: null,
  has_partner: false,
  shared_household: false,
  income_partner_gross: '',
  income_partner_net: '',
  checkbox_income_partner: false,
  pregnant: false,
  has_children: false,
  children_0_5: 0,
  children_6_13: 0,
  children_14_17: 0,
  children_18_24_non_working: 0,
  rental_income: '',
  unemployment_benefit: '',
  pension: '',
  other_income_amount: '',
  checkbox_other_income: false,
  cold_rent: '',
  additional_costs: '',
  heating_costs: '',
  checkbox_housing_costs: false,
};

export type CalculatorResult = {
  grundsicherung: number;
  bedarf: number;
  totalAnrechenbares: number;
  formData: CalculatorFormData;
};

export type ValidationErrors = Record<string, string>;

export interface CalculatorState {
  stepHistory: string[];
  formData: CalculatorFormData;
  isLoading: boolean;
  showCancelModal: boolean;
  validationErrors: ValidationErrors;
  apiError: string | null;
}

export type CalculatorAction =
  | { type: 'PUSH_STEP'; stepId: string }
  | { type: 'POP_STEP' }
  | { type: 'UPDATE_FORM'; data: Partial<CalculatorFormData> }
  | { type: 'SET_LOADING'; value: boolean }
  | { type: 'SHOW_CANCEL_MODAL'; value: boolean }
  | { type: 'SET_ERRORS'; errors: ValidationErrors }
  | { type: 'SET_API_ERROR'; error: string | null };

export interface FieldConfig {
  key: string;
  labelKey: string;
  max?: number;
  mustBeLessThanOrEqualTo?: string;
}

export interface StepperGroupConfig {
  key: string;
  labelKey: string;
  hintKey?: string;
}

export interface StepConfig {
  id: string;
  type: 'income_fields' | 'yes_no' | 'stepper_groups' | 'multi_income' | 'housing' | 'summary' | 'child_ages';
  questionKey?: string;
  questionKeyAlt?: string;
  questionKeyAltCondition?: string;
  hintKey?: string;
  saveKey?: string;
  fields?: FieldConfig[];
  checkboxKey?: string;
  checkboxLabelKey?: string;
  groups?: StepperGroupConfig[];
  next: string | { true: string; false: string } | { childrenOneOrTwo: { true: string; false: string } };
}

export const MAX_STEP_SEQUENCE = [
  'income_user',
  'has_partner',
  'shared_household',
  'income_partner',
  'pregnant',
  'has_children',
  'children_age_groups',
  'child_ages',
  'other_income',
  'housing',
  'summary',
] as const;
